import script from "./MobileMenutItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMenutItem.vue?vue&type=script&setup=true&lang=js"

import "./MobileMenutItem.vue?vue&type=style&index=0&id=ac974a96&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac974a96"]])

export default __exports__